module.exports = __webpack_public_path__ + "img/11-2.42e2006b.png";